import type { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { AppShell } from '@/components/ui/AppShell';
import { ToastProvider } from '@/components/ui/Toast';
import { isStaffPath, requireStaff } from '@/lib/auth-guards';
import { ThemeProvider } from '@/lib/theme';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: async ({ location, context }) => {
    if (isStaffPath(location.pathname)) await requireStaff(context.queryClient);
  },
  component: RootLayout,
});

function RootLayout() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AppShell>
          <Outlet />
        </AppShell>
      </ToastProvider>
    </ThemeProvider>
  );
}
